import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function AdminDashboardPage() {
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      toast.error('Please login first');
      navigate('/admin');
    }
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin');
  };

  return (
    <div className="container py-5 text-center">
      <h3 className="mb-4">Welcome to Admin Dashboard</h3>
      <div className="d-grid gap-3 col-6 mx-auto">
        <Link to="/admin/services" className="btn btn-primary">Manage Services</Link>
        <Link to="/admin/internships" className="btn btn-success">Manage Internships</Link>
        <Link to="/admin/applications" className="btn btn-dark">View Applications</Link>
        <Link to="/admin/pages" className="btn btn-warning">Manage Public Pages</Link>
        <Link to="/" className="btn btn-outline-primary">← Back to Website</Link>
        <button onClick={handleLogout} className="btn btn-outline-danger">Logout</button>
      </div>
    </div>
  );
}
